module.exports = __webpack_public_path__ + "static/media/zocalo12.30f1665f.jpg";